import { FALLBACK_SITE_CONTENT, normalizeSiteContent } from "../utils/siteContent";

export default function AboutPage({ content }) {
  const safeContent = normalizeSiteContent(content);

  return (
    <div className="page-shell section-gap" data-testid="about-page">
      <section className="grid gap-10 md:grid-cols-[1fr_1.1fr] md:items-start" data-testid="about-intro-section">
        <div className="space-y-5">
          <p className="eyebrow" data-testid="about-eyebrow">
            About the firm
          </p>
          <h1 className="headline-lg max-w-2xl" data-testid="about-heading">
            {safeContent.about_heading}
          </h1>
          <p className="body-copy max-w-2xl" data-testid="about-intro-copy">
            {safeContent.about_intro}
          </p>
          <div className="space-y-4">
            {safeContent.about_story.map((paragraph, index) => (
              <p className="body-copy" data-testid={`about-story-${index + 1}`} key={paragraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <div className="overflow-hidden border border-slate-900/10 bg-white p-4 shadow-[18px_18px_0_rgba(15,23,42,0.08)]" data-testid="about-architecture-image-card">
            <img
              alt="Architectural backdrop"
              className="aspect-[5/4] w-full object-cover object-center"
              data-testid="about-architecture-image"
              onError={(event) => {
                event.currentTarget.onerror = null;
                event.currentTarget.src = safeContent.hero_image || FALLBACK_SITE_CONTENT.hero_image;
              }}
              src={safeContent.architecture_image}
            />
          </div>
          <div className="panel-card bg-slate-950 text-white" data-testid="about-attorney-summary-card">
            <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-400" data-testid="attorney-summary-eyebrow">
              Attorney profile
            </p>
            <h2 className="mt-4 text-3xl font-black uppercase tracking-tight" data-testid="attorney-name-heading">
              {safeContent.attorney_name}
            </h2>
            {safeContent.attorney_summary.map((paragraph, index) => (
              <p className="mt-4 text-sm leading-relaxed text-slate-300" data-testid={`attorney-summary-${index + 1}`} key={paragraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-20 grid gap-8 lg:grid-cols-[1fr_1.1fr]" data-testid="about-credentials-section">
        <div className="panel-card" data-testid="credentials-card">
          <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-700" data-testid="credentials-eyebrow">
            Qualifications & memberships
          </p>
          <div className="mt-6 space-y-4">
            {safeContent.credentials.map((item, index) => (
              <div className="border-t border-slate-900/10 pt-4" data-testid={`credential-item-${index + 1}`} key={item}>
                <p className="text-base leading-relaxed text-slate-700">{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="panel-card bg-slate-50" data-testid="timeline-card">
          <p className="text-xs font-bold uppercase tracking-[0.26em] text-amber-700" data-testid="timeline-eyebrow">
            Timeline of experience
          </p>
          <div className="mt-6 space-y-5">
            {safeContent.timeline.map((entry, index) => (
              <div className="grid gap-3 border-t border-slate-900/10 pt-5 md:grid-cols-[120px_1fr]" data-testid={`timeline-entry-${index + 1}`} key={entry}>
                <p className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">0{index + 1}</p>
                <p className="text-base leading-relaxed text-slate-700" data-testid={`timeline-entry-copy-${index + 1}`}>
                  {entry}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}